import { request } from '@umijs/max';

import { SettingsResponse } from './types';

export async function getSettings(): Promise<SettingsResponse> {
  return request('settings', {
    method: 'GET',
  });
}

export async function updateSettings(payload: SettingsResponse): Promise<SettingsResponse> {
  return request('settings', {
    data: payload,
    method: 'PATCH',
  });
}
